// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.go-to-page__label_e8538386 {
  color: #11304d;
  font-weight: 400;
  margin-bottom: 0;
  margin-left: 0.667rem;
}
.go-to-page__label-root_e8538386 {
  margin-bottom: 0 !important;
}
.go-to-page__page-number_e8538386 {
  width: 5.334rem;
}
.go-to-page__text-align_e8538386 {
  text-align: center;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"go-to-page__label": `go-to-page__label_e8538386`,
	"go-to-page__label-root": `go-to-page__label-root_e8538386`,
	"go-to-page__page-number": `go-to-page__page-number_e8538386`,
	"go-to-page__text-align": `go-to-page__text-align_e8538386`
};
export default ___CSS_LOADER_EXPORT___;
